import React, { useEffect } from "react";
import { Button, Card, Dropdown, Space, Tag } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { HiOutlineChevronDown } from "react-icons/hi";
import AppControl from "../../../components";
import { getFixers } from "../../../store/slice/fixers";

const STATUS_COLORS = {
  under_review: "gold",
  approved: "green",
  rejected: "red",
};

const statusLabel = (status) =>
  (status ?? "")
    .split("_")
    .filter(Boolean)
    .map((w) => w[0].toUpperCase() + w.slice(1))
    .join(" ") || "—";

function Fixer() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getFixers());
  }, []);

  const fixerList = useSelector((state) => state.fixers.list);

  const COLUMNS = [
    { Header: "Id", accessor: "id", isVisible: false, disableFilters: true },
    { Header: "Full Name", accessor: "user.fullName" },
    { Header: "Phone Number", accessor: "user.phoneNumber", disableFilters: true },
    {
      Header: "Service Categories",
      accessor: "serviceCategories",
      disableFilters: true,
      Cell: ({ row }) => (
        <Space wrap>
          {(row.values.serviceCategories ?? []).map((c) => (
            <Tag key={c} color="blue">{c}</Tag>
          ))}
        </Space>
      ),
    },
    { Header: "State", accessor: "state" },
    { Header: "District", accessor: "district" },
    { Header: "Primary Service Area", accessor: "primaryServiceArea", disableFilters: true },
    { Header: "Onboarding Source", accessor: "onboardingSource", disableFilters: true },
    {
      Header: "Status",
      accessor: "status",
      disableFilters: true,
      Cell: ({ row }) => (
        <Tag color={STATUS_COLORS[row.values.status] ?? "default"}>
          {statusLabel(row.values.status)}
        </Tag>
      ),
    },
    {
      Header: "Actions",
      disableFilters: true,
      Cell: ({ row }) => (
        <Dropdown
          menu={{
            items: [
              {
                key: "1",
                label: <Link to={`details/${row.values.id}`}>Review</Link>,
              },
            ],
          }}
        >
          <Button>
            <Space>
              Actions <HiOutlineChevronDown />
            </Space>
          </Button>
        </Dropdown>
      ),
    },
  ];

  return (
    <Card title="FIXER LIST">
      <AppControl control="table" columns={COLUMNS} data={fixerList} />
    </Card>
  );
}

export default Fixer;
